import { Types as TypesModule } from '@/app/store_growth/store/Index'

import { getLongGrid } from '@/app/store_growth/Services'
import { addNamespace } from '@/app/shared/utils/NamespaceHelper'

const NAMESPACE = 'storeGrowth/storesWithoutGrowth/'

const _types = {
  getters: {
    METRICS: 'GETTER_METRICS',
    SORT_FIELD: 'GETTER_SORT_FIELD',
    HAVING_FILTERS: 'GETTER_HAVING_FILTERS',
    PAYLOAD_PARAMETERS: 'GETTER_PAYLOAD_PARAMETERS'
  },
  actions: {
    FETCH_LONG_GRID: 'FETCH_LONG_GRID'
  },
  mutations: {
    SET_DEFAULT_PARAMETERS: 'SET_DEFAULT_PARAMETERS',
    SET_GRID: 'SET_GRID'
  }
}

export const Types = addNamespace(NAMESPACE, _types)

const StoresWithoutGrowth = {
  namespaced: true,
  state: {
    metrics: null
  },
  getters: {
    [_types.getters.HAVING_FILTERS]: (state, getters, rootState, rootGetters) => {
      const firstNormalMetric = rootGetters[TypesModule.getters.METRICS].normal[0]
      const secondNormalMetric = rootGetters[TypesModule.getters.METRICS].normal[1]
      return [`sum(${secondNormalMetric}) > sum(${firstNormalMetric})`, `sum(${firstNormalMetric}) <> 0`]
    },
    [_types.getters.PAYLOAD_PARAMETERS]: (state, getters, rootState, rootGetters) => {
      const payload = {
        parameters: {
          store_dimensions: ['retail_name_store_name', 'store_id'],
          product_dimensions: {},
          metrics: rootGetters[TypesModule.getters.METRICS],
          fact: {
            type: 'table',
            name: rootState.storeGrowth.accumulatedSalesDateOption.fact_name
          },
          sort: {
            field: rootGetters[TypesModule.getters.SORT_FIELD],
            dir: 'DESC'
          },
          limit: 50,
          offset: 0,
          store_filters: {
            store_type_id: [1]
          },
          product_filters: {},
          having_filters: getters[_types.getters.HAVING_FILTERS]
        }
      }
      return payload
    }
  },
  actions: {
    async [_types.actions.FETCH_LONG_GRID] ({ getters }) {
      const payload = getters[_types.getters.PAYLOAD_PARAMETERS]
      const longGrid = await getLongGrid(payload)
      return longGrid
    }
  }
}

export default StoresWithoutGrowth



// WEBPACK FOOTER //
// ./src/app/store_growth/store/StoresWithoutGrowth.js